import { render, staticRenderFns } from "./LocationNumberRateLimit.vue?vue&type=template&id=c2c899e6&scoped=true&"
import script from "./LocationNumberRateLimit.vue?vue&type=script&lang=js&"
export * from "./LocationNumberRateLimit.vue?vue&type=script&lang=js&"
import style0 from "./LocationNumberRateLimit.vue?vue&type=style&index=0&id=c2c899e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c899e6",
  null
  
)

export default component.exports